import { createFileRoute, useParams } from '@tanstack/react-router';
import { AssistantCreation } from '../../../../features/assistantform/pages/AssistantCreation';

export const Route = createFileRoute('/_app/assistant/create/$conversationId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { conversationId } = useParams({
    from: '/_app/assistant/create/$conversationId',
  });

  // Files are managed locally by the upload modal - no need to fetch from backend
  return <AssistantCreation conversationId={conversationId} files={[]} />;
}
